import {
    IMPERSONATE_USER_REQUESTED,
    IMPERSONATE_USER_SUCCESS,
    IMPERSONATE_USER_FAILED,
    STOP_IMPERSONATION,
} from '../actions/types';

const initialState = {
    impersonatedUser: null,
    isImpersonating: false,
    loading: false,
    error: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case IMPERSONATE_USER_REQUESTED:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case IMPERSONATE_USER_SUCCESS:
            return {
                ...state,
                impersonatedUser: action.payload,
                isImpersonating: true,
                loading: false,
            };
        case IMPERSONATE_USER_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case STOP_IMPERSONATION:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
